import { Component, Input } from '@angular/core';
import { Colors } from 'src/app/models/enums';

import { CommonModule } from '@angular/common';
@Component({
  selector: 'app-color-detail',
  templateUrl: './color.component.html',
  imports: [CommonModule],
  styleUrl: './color.component.scss',
})
export class ColorComponent {
  @Input() color: string;

  public Colors = Colors;
}
